
   import Vue from 'vue'
   import { formatDate } from '@/services/DateHelpers'

   export default Vue.extend({
      name: 'DateDisplay',
      props: {
         label: String,
         value: [String, Date],
         format: { type: String, default: 'd MMM yyyy' },
      },
      computed: {
         displayValue(): string {
            if (this.value === undefined) {
               return ''
            }
            return formatDate(this.value, this.format)
         },
      },
   })
